module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page video-page info-page"
  }, [_c('div', {
    staticClass: "d-flex"
  }, [(_vm.isPageReady) ? _c('div', {
    staticClass: "page-content"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "description-container",
    attrs: {
      "xs6": ""
    }
  }, [_c('h4', [_vm._v("How it works")]), _vm._v(" "), _c('p', [_vm._v("\n            Create one of a kind live video experiences designed to maximize\n            sales with exclusive products & downloads for your most engaging\n            customers. Pay as you go. Unused credit rolls over to your next\n            broadcast. All broadcasts include delivery of all resolutions up\n            to HD 1080p.\n          ")]), _vm._v(" "), _c('p', [_vm._v("\n            To learn more visit the\n            "), _c('a', {
    attrs: {
      "href": "//support.yousound.com/en/articles/4490519-live-video-cost",
      "target": "_blank"
    }
  }, [_vm._v("Frequently Asked Questions")])]), _vm._v(" "), (!_vm.isStreamRunning) ? _c('v-btn', {
    staticClass: "mt-4",
    attrs: {
      "round": "",
      "dark": "",
      "color": "blue"
    },
    on: {
      "click": _vm.gotoNextView
    }
  }, [_vm._v("Setup Live Stream")]) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "estimate-container",
    attrs: {
      "xs6": ""
    }
  }, [_c('h4', [_vm._v("Estimate your cost")]), _vm._v(" "), _c('div', {
    staticClass: "label"
  }, [_vm._v("Duration of an average live stream")]), _vm._v(" "), _c('v-layout', {
    staticClass: "input"
  }, [_c('v-flex', {
    attrs: {
      "xs5": ""
    }
  }, [_c('div', {
    staticClass: "duration"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.durationDetail.hour),
      expression: "durationDetail.hour"
    }],
    attrs: {
      "type": "number",
      "min": "0",
      "max": "12",
      "size": "3"
    },
    domProps: {
      "value": (_vm.durationDetail.hour)
    },
    on: {
      "change": _vm.handleDurationDetailChange,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.durationDetail, "hour", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v(":")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.durationDetail.min),
      expression: "durationDetail.min"
    }],
    attrs: {
      "type": "number",
      "min": "0",
      "max": "59",
      "size": "3"
    },
    domProps: {
      "value": (_vm.durationDetail.min)
    },
    on: {
      "change": _vm.handleDurationDetailChange,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.durationDetail, "min", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v(":")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.durationDetail.sec),
      expression: "durationDetail.sec"
    }],
    attrs: {
      "type": "number",
      "min": "0",
      "max": "59",
      "size": "3"
    },
    domProps: {
      "value": (_vm.durationDetail.sec)
    },
    on: {
      "change": _vm.handleDurationDetailChange,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.durationDetail, "sec", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "duration-helper"
  }, [_c('span', [_vm._v("hours")]), _vm._v(" "), _c('span', [_vm._v("mintues")]), _vm._v(" "), _c('span', [_vm._v("seconds")])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs7": "",
      "slider-container": ""
    }
  }, [_c('v-slider', {
    attrs: {
      "min": "0",
      "max": "186",
      "step": "1",
      "hide-details": ""
    },
    on: {
      "input": _vm.handleDurationMirrorChange
    },
    model: {
      value: (_vm.durationMirror),
      callback: function($$v) {
        _vm.durationMirror = $$v
      },
      expression: "durationMirror"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "label"
  }, [_vm._v("Live stream view count")]), _vm._v(" "), _c('v-layout', {
    staticClass: "input"
  }, [_c('v-flex', {
    attrs: {
      "xs5": ""
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.viewers),
      expression: "viewers"
    }],
    attrs: {
      "type": "number",
      "min": "0",
      "max": "10000000"
    },
    domProps: {
      "value": (_vm.viewers)
    },
    on: {
      "change": _vm.handleViewersChange,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.viewers = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs7": "",
      "slider-container": ""
    }
  }, [_c('v-slider', {
    attrs: {
      "min": "0",
      "max": "290",
      "step": "1",
      "hide-details": ""
    },
    on: {
      "input": _vm.handleViewersMirrorChange
    },
    model: {
      value: (_vm.viewersMirror),
      callback: function($$v) {
        _vm.viewersMirror = $$v
      },
      expression: "viewersMirror"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "label"
  }, [_vm._v("How long does the average viewer watch?")]), _vm._v(" "), _c('div', {
    staticClass: "radio-container"
  }, [_c('div', {
    staticClass: "radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.percentage),
      expression: "percentage"
    }],
    attrs: {
      "id": "average-30",
      "type": "radio",
      "name": "percentage",
      "value": "30"
    },
    domProps: {
      "checked": _vm._q(_vm.percentage, "30")
    },
    on: {
      "change": function($event) {
        _vm.percentage = "30"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "average-30"
    }
  }, [_vm._v("30% of"), _c('br'), _vm._v("the live stream")])]), _vm._v(" "), _c('div', {
    staticClass: "radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.percentage),
      expression: "percentage"
    }],
    attrs: {
      "id": "average-50",
      "type": "radio",
      "name": "percentage",
      "value": "50"
    },
    domProps: {
      "checked": _vm._q(_vm.percentage, "50")
    },
    on: {
      "change": function($event) {
        _vm.percentage = "50"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "average-50"
    }
  }, [_vm._v("50% of"), _c('br'), _vm._v("the live stream")])]), _vm._v(" "), _c('div', {
    staticClass: "radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.percentage),
      expression: "percentage"
    }],
    attrs: {
      "id": "average-90",
      "type": "radio",
      "name": "percentage",
      "value": "90"
    },
    domProps: {
      "checked": _vm._q(_vm.percentage, "90")
    },
    on: {
      "change": function($event) {
        _vm.percentage = "90"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "average-90"
    }
  }, [_vm._v("90% of"), _c('br'), _vm._v("the live stream")])]), _vm._v(" "), _c('div', {
    staticClass: "radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.percentage),
      expression: "percentage"
    }],
    attrs: {
      "id": "average-100",
      "type": "radio",
      "name": "percentage",
      "value": "100"
    },
    domProps: {
      "checked": _vm._q(_vm.percentage, "100")
    },
    on: {
      "change": function($event) {
        _vm.percentage = "100"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "average-100"
    }
  }, [_vm._v("100% of"), _c('br'), _vm._v("\n                the live stream")])])]), _vm._v(" "), _c('div', {
    staticClass: "total"
  }, [_c('label', [_vm._v("Estimated Total")]), _vm._v(" "), _c('span', [_vm._v("$" + _vm._s(_vm._f("formatNumber")(_vm.totalPrice)))])])], 1)], 1)], 1) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-16f87427","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/video/estimate.vue
// module id = 1625
// module chunks = 180